import { message,TreeSelect } from "antd";
import React, { useEffect, useState } from "react";
import useRequest from "@/utils/useRequest";
import _ from "lodash";

function list_to_tree(list) {
 
  var map = {}, node, roots = [], i;
  var ids = new Set(); // 用于存储所有节点Id

  // 遍历一遍列表，获取所有节点的Id
  for (i = 0; i < list.length; i += 1) {
    ids.add(list[i].Id);
  }

  // 遍历列表，构建树形结构
  for (i = 0; i < list.length; i += 1) {
    map[list[i].Id] = i; // initialize the map
    list[i].key = list[i].Id;
    list[i].title = list[i].Name;
    list[i].value = list[i].Id;
    list[i].children = []; // initialize the children

    // 检查父节点是否存在于ids集合中，如果不存在则将该节点作为根节点处理
    if (list[i].Pid !== -1 && !ids.has(list[i].Pid)) {
      roots.push(list[i]);
    }
  }

  // 再次遍历列表，构建树形结构
  for (i = 0; i < list.length; i += 1) {
    node = list[i];
    if (node.Pid !== -1 && ids.has(node.Pid)) {
      list[map[node.Pid]].children.push(node);
    } else if (node.Pid === -1) {
      roots.push(node);
    }
  }

  return roots;
}

const DeptTreeSelect = (props) => {
    const { value, onChange } = props;
    const [loading, setLoading] = useState(false);
    const [gData, setData] = useState([]);
    const { request } = useRequest();

    const Refresh = async () => {
      setLoading(true);
      let result = await request("/api/v2/private/dept/all", "POST", "json", {});
      if (result.success) {
        //组装成树形结构
        //{ icon: <CarryOutOutlined />,disabled:true, key: "-1", title: orgName }
        let tree = list_to_tree(_.sortBy(result.data, "Left"));
        setLoading(false);
        setData(tree);
      }
    }

    useEffect(()=>{
      Refresh();
  },[]);

    const handleChange = value => {
        if(onChange) onChange(value);
      };

    return (<TreeSelect
        className={props.className}
        placeholder="请选择部门..."
        //mode="multiple"
        defaultValue={value}
        treeDefaultExpandAll
        onChange={handleChange}
        treeData={gData}
    >
    </TreeSelect>);
}

export default DeptTreeSelect;